import React, { useState } from "react";
import { api, formatApiErrorDetail, API_BASE } from "../lib/api";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Paperclip, X, ExternalLink } from "lucide-react";

export default function FileUpload({ value, onChange, testid = "file-upload" }) {
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/attachments", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success(`Uploaded ${data.filename}`);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Upload failed");
    } finally {
      setBusy(false);
      // reset so same-file re-select fires change
      e.target.value = "";
    }
  };

  const backendBase = process.env.REACT_APP_BACKEND_URL;
  const previewUrl = value ? `${backendBase}${value}` : null;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <label className="inline-flex items-center gap-2 h-10 px-3 rounded-md border border-slate-300 bg-white hover:bg-slate-50 cursor-pointer text-sm">
        <Paperclip className="w-4 h-4" />
        {busy ? "Uploading…" : (value ? "Replace file" : "Attach photo / PDF")}
        <input type="file" accept=".jpg,.jpeg,.png,.webp,.pdf" className="hidden" onChange={handle} data-testid={testid} disabled={busy} />
      </label>
      {value && (
        <>
          <a href={previewUrl} target="_blank" rel="noreferrer" className="text-xs text-blue-700 underline inline-flex items-center gap-1" data-testid={`${testid}-preview`}>
            <ExternalLink className="w-3 h-3" /> View
          </a>
          <Button type="button" variant="ghost" size="sm" onClick={() => onChange(null)} data-testid={`${testid}-clear`}>
            <X className="w-4 h-4" />
          </Button>
        </>
      )}
    </div>
  );
}
